/* RESPONSIBLE TEAM: team-reporting */

import { formatSeconds } from '@/features/report-snapshots/formatters/duration';

export function formatAxisValue(value: number): string {
  const precision = value % 1000 === 0 ? 0 : 1;

  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(precision)}M`;
  } else if (value >= 1000) {
    return `${(value / 1000).toFixed(precision)}K`;
  } else {
    return value.toString();
  }
}

export function yAxisFormatter(isPercent: boolean) {
  return function (this: { value: number | string }) {
    const numericValue =
      typeof this.value === 'number' ? this.value : parseFloat(String(this.value));
    return isPercent ? (numericValue * 100).toFixed(0) + '%' : formatAxisValue(numericValue);
  };
}

export function relativeValuesYAxisFormatter(this: { value: number | string }) {
  return `${this.value}%`;
}

export function durationYAxisFormatter(this: { value: number | string }) {
  const numericValue = typeof this.value === 'number' ? this.value : parseFloat(String(this.value));

  return formatSeconds(numericValue);
}
